import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import Toolbar from '../../controls/Toolbar.jsx';
import Utils from '../../../utils/utils.js';

const NotificationDetails = ({
  payload,
  userId,
  status,
  createdAt,
  updatedAt,
}) => {
  const [translate] = useTranslation();

  const formLabel = useCallback((label, size = '4') => {
    return (
      <Form.Label column={!!size} sm={size} className='h6 fw-bold'>
        {translate(label)}
      </Form.Label>
    );
  }, [translate]);

  const readOnlyFormControl = useCallback((label, value) => {
    return (
      <Form.Group as={Row} className='gx-1'>
        {formLabel(label)}
        <Col sm='8'>
          <Form.Control plaintext readOnly value={value} />
        </Col>
      </Form.Group>
    );
  }, [formLabel]);

  return (
    <div className='card h-100 overflow-hidden'>
      <div className='card-header border-bottom sticky-top'>
        <Toolbar heading={payload?.title} />
      </div>
      <div className='card-body h-100 overflow-auto'>
        <Form>
          {readOnlyFormControl('OTM_NOTIFICATIONS_USER', userId)}
          {readOnlyFormControl('OTM_NOTIFICATIONS_STATUS', status)}
          {readOnlyFormControl('OTM_NOTIFICATIONS_CREATED_AT', Utils.getFormattedDateTime(createdAt))}
          {readOnlyFormControl('OTM_NOTIFICATIONS_UPDATED_AT', Utils.getFormattedDateTime(updatedAt))}
          {formLabel('OTM_NOTIFICATIONS_PAYLOAD', '')}
          <pre>
            <code>
              {JSON.stringify(payload, null, 2).slice(1, -1).trim()}
            </code>
          </pre>
        </Form>
      </div>
    </div>
  );
};

export default NotificationDetails;